import {Pipe, PipeTransform} from '@angular/core';
import {AnyObject, FormCurrentData, FormFieldConfig} from '@mri/types';

@Pipe({
  name: 'formFieldShow',
  standalone: true
})
export class FormFieldShowPipe implements PipeTransform {

  transform<T = AnyObject >(field: FormFieldConfig<T>, data: FormCurrentData): boolean{
    return !(field?.hide?.(data) || false);
  }

}
